import styled from "@emotion/styled";
import TextInput from "metabase/components/TextInput";

export const QuestionPickerRoot = styled.div`
  padding: 1rem;
`;

export const BreadcrumbsWrapper = styled.div`
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
`;

export const SearchInput = styled(TextInput)`
  margin-bottom: 1rem;
`;
